import axios from 'axios'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Check both storages for the token
    const isRememberMe = localStorage.getItem('remember_me') === 'true'
    const storage = isRememberMe ? localStorage : sessionStorage
    const token = storage.getItem('session')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if we're already on a login/auth page or if this is a login request
      const isAuthRequest =
        error.config?.url?.includes('/auth/login') ||
        error.config?.url?.includes('/auth/register') ||
        error.config?.url?.includes('/auth/refresh')
      const isOnAuthPage = window.location.pathname.startsWith('/auth/')

      if (!isAuthRequest && !isOnAuthPage) {
        // Clear from both storages
        localStorage.removeItem('session')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('remember_me')
        sessionStorage.removeItem('session')
        sessionStorage.removeItem('refresh_token')
        sessionStorage.removeItem('remember_me')
        window.location.href = '/auth/login'
      }
    }
    return Promise.reject(error)
  },
)
